export default $axios => ({
    getVacancies() {
        return $axios({
            method: 'GET',
            url: '/base/vacancies'
        });
    },
    getVacancy(slug) {
        return $axios({
            method: 'GET',
            url: `/base/vacancies/${slug}`
        });
    },
    postVacancy(data) {
        return $axios({
            method: 'POST',
            url: `/base/send-resume`,
            data: data
        });
    }
});
